<script lang="ts">let { size = "20" } = $props();
</script>

<svg
	height={size}
	style="fill: currentColor"
	viewBox="0 0 28.35 28.35"
	xmlns="http://www.w3.org/2000/svg"
>
	<path
		d="m14.18 28.35c-3.79 0-7.35-1.47-10.02-4.15-2.69-2.68-4.16-6.24-4.16-10.03s1.47-7.34 4.15-10.02 6.24-4.15 10.03-4.15 7.34 1.47 10.02 4.15 4.15 6.24 4.15 10.02-1.47 7.34-4.15 10.02-6.24 4.15-10.02 4.15zm-.47-10.95c-.14 1.37-.51 3.19-1.5 4.1h3.93c-1-.91-1.37-2.73-1.5-4.1.6.94 1.63 1.5 2.74 1.5 1.79 0 3.25-1.46 3.25-3.25s-1.46-3.25-3.25-3.25c-.39 0-.77.07-1.13.2.74-.62 1.17-1.53 1.17-2.5 0-1.79-1.46-3.25-3.25-3.25s-3.25 1.46-3.25 3.25c0 .97.43 1.88 1.17 2.5-.36-.13-.74-.2-1.12-.2-1.79 0-3.25 1.46-3.25 3.25s1.46 3.25 3.25 3.25c1.11 0 2.13-.56 2.74-1.5z"
	/>
</svg>
